import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const metadata = z.object({
  mediaDataId: z.string(),
});

export const MetadataResponseSchema = createResponseSchema(metadata);
